export const appointment_types = {
    FETCH_APPOINTMENTS_START:'FETCH_APPOINTMENTS_START',
    SET_APPOINTMENTS_START:'SET_APPOINTMENTS_START',
    ADD_APPOINTMENT_START:'ADD_APPOINTMENT_START',
    SHOW_VIDEO_MODAL: 'SHOW_VIDEO_MODAL',
    SET_APPOINTMENT_START:'SET_APPOINTMENT_START'
}